import useRequest from '@/websdk/utils/request';
import { useEffect, useState } from 'react';

export default (function (params) {
  const [dataList, setDataList] = useState('');
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_DEVICES_HIVE_SN_BY_LINE',
    url: ``,
    method: 'GET',
  });

  useEffect(() => {
    if (params) {
      let url = `/api/machine/extra/hivesn`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  useEffect(() => {
    if (data) {
      setDataList(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return [dataList || '', isRequestSuccessed, exec];
});
